<popper ref="popper" class="autoselect" :class="popperContentClass">

    <!-- Search box for autoselect -->
    <div slot="anchor" class="autoselect__input-box">

        <!-- Class `autoselect__input` in overidden by Multiselect.
            Don't change name -->
        <input ref="input" class="autoselect__input" type="text" v-model="textInput"
            :class="{ 'autoselect__input--loading': loading }"
            :placeholder="placeholder"
            :disabled="disabled"
            @input="onInput"
            @blur="onBlur"
            @focus="onFocus"
            @keydown.down="onKeyDown"
            @keydown="showOptions"
            @keydown.tab="onKeyTab"/>
        <spinner v-if="loading" class="autoselect__loading"></spinner>
    </div>

    <!-- Dropdown options -->
    <div v-if="!disabled" @click="onOptionSelect(option)" class="autoselect__option" v-for="(option, index) in options"
        :ref="'optionLabel'" @keydown="onOptionsKeyDown($event, option)" :tabindex="index">
        <slot :option="option">
            {{ toText(option) }}
        </slot>
    </div>

    <!-- Message when empty list found -->
    <slot name="empty" v-if="showEmpty">
        <div class="autoselect__no-records">No matching record found</div>
    </slot>

</popper>
